export default "__VITE_ASSET__Dbb5Vp90__"